const getContentType = info => {
  if (info?.isLive === '1' || info?.media?.isLive === '1') {
    return 'canal tv';
  }
  if (info?.isSerie || info?.media?.serie) {
    return 'serie';
  }
  return 'pelicula';
};

export default getContentType;
